import { PlayerCoursePage } from '@hendrx/core/courses';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/player/courses/$courseDraftIdentifier/')({
  component: PlayerCoursePage
});
